import { post } from './http'
export default {
  //登录
  login(params) {
    return post('/sign_in', params)
  },
  //注册
  signUp(params) {
    return post('/sign_up', params)
  },
  //忘记密码
  forgetPwd(params) {
    return post('/forget_pwd', params)
  },
  //首页
  getIndex(params) {
    return post('/index', params)
  },
  //通知列表
  getNoticeList(params) {
    return post('/notice_list', params)
  },
  //通知详情
  getNoticeDetail(params) {
    return post('/notice_detail', params)
  },
  //获取用户信息
  getUserInfo(params) {
    return post('/user/check_sessionToken', params)
  },
  //修改用户信息
  ModifyUserInfo(params) {
    return post('/user/modify_info', params)
  },
  //修改用户密码
  ModifyPwd(params) {
    return post('/user/modify_pwd', params)
  },
  //获取考试信息
  getExamInfo(params) {
    return post('/user/exam_info', params)
  },
  //获取考试-专业列表
  getExamList(params) {
    return post('/user/exam_cat_list', params)
  },
  //获取考试-专业-课程列表
  getExamCourseList(params) {
    return post('/user/exam_cat_course_list', params)
  },
  //确认报名
  confirmApply(params) {
    return post('/user/confirm_apply', params)
  },
  //报名列表
  getApplyList(params) {
    return post('/user/apply_list', params)
  },
  //上传缴费证明
  uploadPayCert(params) {
    return post('/user/upload_pay_cert', params)
  },
  //查看原因
  showFailInfo(params) {
    return post('/user/show_fail_info', params)
  },
  //查看准考证
  showAdmissionCard(params) {
    return post('/user/show_admission_card', params)
  },
  //修改准考证号
  changeAdmissionCard(params) {
    return post('/user/change_admission_card_code', params)
  },
  //获取七牛上传参数
  getUploadToken(params) {
    return post('/upload_token', params)
  },
  // 获取该学生已经报名的课程
  getSelCourse(params) {
    return post('/user/exam_cat_sel_course', params)
  },
  //获取该学生已经报名的专业的准考证号
  getAdmissionCardCode(params) {
    return post('/user/exam_cat_admission_card_code', params)
  },
  //校验准考证号是否唯一
  checkUniqueAdmissionCardCode(params) {
    return post('/user/check_unique_admission_card_code', params)
  },
  //上传工作实习证明
  uploadWorkCert(params) {
    return post('/user/upload_work_cert', params)
  },
  //获取註冊验证码
  getCheckCode(params) {
    return post('/get_check_code', params)
  },
  //获取忘記密碼验证码
  getForgetCheckCode(params) {
    return post('/get_check_code_forget', params)
  },
  //获取论文计划信息
  getPaperInfo(params) {
    return post('/user/paper/info', params)
  },
  //获取学位论文计划信息
  getDegreePaperInfo(params) {
    return post('/user/degree_paper/info', params)
  },
  //上传论文
  confirmSubmit(params) {
    return post('/user/paper/confirm_submit', params)
  },
  //上传学位论文
  confirmDegreeSubmit(params) {
    return post('/user/degree_paper/confirm_submit', params)
  },
  //获取论文列表
  getPaperList(params) {
    return post('/user/paper/list', params)
  },
  //获取学位论文列表
  getDegreePaperList(params) {
    return post('/user/degree_paper/list', params)
  },
  //修改论文准考证号、专业
  modifyAdmissionCode(params) {
    return post('/user/paper/change_admission_card_code', params)
  },
  //修改学位论文准考证号、专业
  modifyDegreeAdmissionCode(params) {
    return post('/user/degree_paper/change_admission_card_code', params)
  },
  //论文信息的编辑
  mofifyPaper(params) {
    return post('/user/paper/modify', params)
  },
  //学位论文信息的编辑
  mofifyDegreePaper(params) {
    return post('/user/degree_paper/modify', params)
  },
  //查看论文审核失败原因
  showPaperFailInfo(params) {
    return post('/user/paper/show_fail_info', params)
  },
  //查看学位论文审核失败原因
  showDegreePaperFailInfo(params) {
    return post('/user/degree_paper/show_fail_info', params)
  },
  //校验论文上传
  checkPaperStatus(params) {
    return post('/user/check_paper_status', params)
  },
  //校验论文上传
  checkDegreePaperStatus(params) {
    return post('/user/check_degree_paper_status', params)
  },
  //获取论文计划获取专业列表
  getPaperCatList(params) {
    return post('user/paper/paper_cat_list', params)
  },
  //获取学位论文计划获取专业列表
  getDegreePaperCatList(params) {
    return post('user/degree_paper/degree_paper_cat_list', params)
  },
  //培训报名部分---------------------------
  //培训报名列表
  getTrainApplyList(params) {
    return post('/user/train/apply_list', params)
  },
  //培训修改准考证号
  changeTrainAdmissionCard(params) {
    return post('/user/train/change_admission_card_code', params)
  },
  //培训校验准考证号是否唯一
  checkTrainUniqueAdmissionCardCode(params) {
    return post('/user/train/check_unique_admission_card_code', params)
  },
  //培训确认报名
  confirmTrainApply(params) {
    return post('/user/train/confirm_apply', params)
  },
  //培训查看原因
  showTrainFailInfo(params) {
    return post('/user/train/show_fail_info', params)
  },
  //培训获取该学生已经报名的专业的准考证号
  getTrainAdmissionCardCode(params) {
    return post('/user/train/train_cat_admission_card_code', params)
  },
  //培训获取培训-专业-课程列表
  getTrainCourseList(params) {
    return post('/user/train/train_cat_course_list', params)
  },
  //培训获取培训-专业列表
  getTrainList(params) {
    return post('/user/train/train_cat_list', params)
  },
  //培训获取该学生已经报名的课程
  getTrainSelCourse(params) {
    return post('/user/train/train_cat_sel_course', params)
  },
  //培训获取培训信息
  getTrainInfo(params) {
    return post('/user/train/train_info', params)
  },
  //培训上传缴费证明
  uploadTrainPayCert(params) {
    return post('/user/train/upload_pay_cert', params)
  },
  //培训查看准考证
  showTrainAdmissionCard(params) {
    return post('/user/train/show_admission_card', params)
  },
  //获取问答列表
  getAskList(params) {
    return post('/user/ask/list', params)
  },
  //添加问答记录
  addAsk(params) {
    return post('/user/ask/add', params)
  },
  //标记学位论文提问情况
  markDegreePaperAsk(params) {
    return post('/user/degree_paper/ask', params)
  },
}



// WEBPACK FOOTER //
// ./src/service/api.js